// The API is not available for this functionality
import * as React from 'react'

import { PanelDetails } from 'components/attacks/details/AttackStyles'
import Row from 'components/Row'
import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'
import ApiTrigger from 'components/common/ApiTrigger'
import useAuth from 'hooks/use-auth'
import theme from 'theme'

const UserDetails: React.FC<{
  user: Record<string, any>
}> = ({ user }) => {
  const { fetchSession } = useAuth()
  const [editingName, setEditingName] = React.useState(false)
  const [firstNameValue, setFirstNameValue] = React.useState(
    user.first_name || ''
  )
  const [lastNameValue, setLastNameValue] = React.useState(user.last_name || '')

  const hasName = user.first_name || user.last_name
  const firstName = user.first_name ? user.first_name + ' ' : ''
  const lastName = user.last_name ? user.last_name : ''
  const actionLabel = hasName ? 'Change' : 'Set Name'
  const nameContent = hasName ? `${firstName}${lastName}` : <div />
  return (
    <PanelDetails>
      <Row
        action={
          editingName ? null : (
            <Button secondary onClick={() => setEditingName(true)}>
              {actionLabel}
            </Button>
          )
        }
        css={{
          paddingTop: 0
        }}
        label="Name"
        value={
          editingName ? (
            <div
              css={{
                display: 'grid',
                alignItems: 'center',
                gap: theme.space[1],
                gridTemplateColumns: 'repeat(4, minmax(64px, 1fr))',
                gridTemplateRows: 'repeat(2, minmax(0, 1fr))',
                gridColumn: '2 / span 2',
                gridRowGap: theme.space[3],
                [theme.mq[0]]: {
                  gap: theme.space[2],
                  gridTemplateColumns:
                    'repeat(2, minmax(64px, 1fr)) repeat(2, minmax(48px, 0.5fr))',
                  gridTemplateRows: 'auto'
                }
              }}
            >
              <InputTextField
                nomargin
                css={{
                  gridColumn: '1 / span 2',
                  [theme.mq[0]]: {
                    gridColumn: '1 / span 1'
                  }
                }}
                defaultValue={firstNameValue}
                name="firstName"
                placeholder="First Name"
                // subtext="This is how this user's name will appear to the rest of your organization."
                onChange={event => setFirstNameValue(event.target.value)}
              />
              <InputTextField
                nomargin
                css={{
                  gridColumn: '3 / span 2',
                  [theme.mq[0]]: {
                    gridColumn: '2 / span 1'
                  }
                }}
                defaultValue={lastNameValue}
                name="lastName"
                placeholder="Last Name"
                // subtext="This is how this user's name will appear to the rest of your organization."
                onChange={event => setLastNameValue(event.target.value)}
              />
              <ApiTrigger
                primary
                as={Button}
                css={{
                  gridColumn: '3 / span 1'
                }}
                errorToastMessage="There was an issue updating your name. Please try again later."
                request={{
                  url: '/users/self',
                  method: 'PATCH',
                  data: {
                    first_name: firstNameValue,
                    last_name: lastNameValue
                  }
                }}
                successToastMessage="Your name has been successfully updated."
                onSuccess={() => {
                  fetchSession()
                  setEditingName(false)
                }}
              >
                Save
              </ApiTrigger>
              <Button
                secondary
                css={{
                  gridColumn: '4 / span 1'
                }}
                onClick={() => setEditingName(false)}
              >
                Cancel
              </Button>
            </div>
          ) : (
            nameContent
          )
        }
      />

      <Row label="Email" value={user.identifier} />
    </PanelDetails>
  )
}

export default UserDetails
